import React from 'react';

/**
 * This is rendered when a thumbnail is invalid or fails to render
 * It's an empty placeholder for now but we can add a default image here later.
 * @param {*} props 
 */
export default function InvalidThumbnail(props){
    const {width, height} = props;

    const styles = {
		thumbnailWrapper: {
			width: width,
			height: height
		}
	};

    return(<div style={styles.thumbnailWrapper}></div>);
}